import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Overlay from 'components/atoms/Overlay/Overlay';
import Txt from 'components/atoms/Txt/Txt';
import { ConsentStatus } from 'components/templates/ThirdPartyTrackingProvider/useCookieConsentStatus';
import TranslationWrapper from 'components/templates/Translation/TranslationWrapper';
import useExternalLink from 'hooks/useExternalLink';
import useFrontEndEventTrigger from 'hooks/useFrontEndEventTrigger';
import { useTranslation } from 'next-i18next';
import classes from './CookieBanner.module.scss';

export type Props = {
  onConsentStatusChanged: (consentStatus: ConsentStatus) => void;
};

const namespace = 'cookies';

export default function CookieBanner({ onConsentStatusChanged }: Props) {
  const { frontEndEventTrigger } = useFrontEndEventTrigger();
  const cookiesUrl = useExternalLink('cookies');
  const { t } = useTranslation(namespace);

  return (
    <Overlay>
      <TranslationWrapper namespace={namespace}>
        <Card
          className={classes.card}
          role="dialog"
          aria-labelledby="cookiebannertitle"
          aria-describedby="cookiebannerdesc"
        >
          <Heading level={3} className={classes.heading} id="cookiebannertitle">
            We Use Cookies
          </Heading>
          <Txt component="div" id="cookiebannerdesc" asMarkdown skipTranslation>
            {t(
              'We use cookies, pixels, and other tracking technologies on this site. Some are strictly necessary to run the site, but the following are optional:  1. Cookies measuring how the site is used 2. Cookies enabling personalisation of the site 3. Cookies for advertising, marketing, and social media  The above cookies may transfer your information to third parties, some of whom may be outside your country. Your personal data/information may be not as well protected as in your country. If you accept these cookies, you consent to your data being transferred abroad and accept the associated risks of foreign government agencies having access to your data. Learn more in our [Cookie Policy]({{cookiesUrl}}).',
              { cookiesUrl },
            )}
          </Txt>
          <div className={classes.buttons}>
            <Button
              className={classes.button}
              buttonType="secondary"
              buttonSize="normal"
              component={Txt}
              skipTranslation={true}
              onClick={() => {
                onConsentStatusChanged(ConsentStatus.NOT_CONSENTED);
                frontEndEventTrigger('Cookie consent', 'Necessary');
              }}
            >
              <Txt>Only Strictly Necessary Cookies</Txt>
            </Button>
            <Button
              className={classes.button}
              buttonType="secondary"
              buttonSize="normal"
              component={Txt}
              skipTranslation={true}
              onClick={() => {
                onConsentStatusChanged(ConsentStatus.CONSENTED);
                frontEndEventTrigger('Cookie consent', 'All');
              }}
            >
              <Txt>Accept All Cookies</Txt>
            </Button>
          </div>
        </Card>
      </TranslationWrapper>
    </Overlay>
  );
}
